<div class="checkout-page">
  <div>
    <p-button
      label="Back to cart"
      icon="pi pi-arrow-left"
      (onClick)="backToCart()"
    ></p-button>
  </div>

  <div class="grid checkout-form">
    <div class="col-8">
      <form [formGroup]="checkoutFormGroup">
        <div class="formgrid grid fluid">
          <div class="field col">
            <label for="name">Name</label>
            <input
              formControlName="name"
              id="name"
              type="text"
              class="inputfield w-full"
              pInputText
            />
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['name'].invalid"
              >Name is required</small
            >
          </div>
          <div class="field col">
            <label for="email">Email</label>
            <input
              formControlName="email"
              id="email"
              type="text"
              class="inputfield w-full"
              pInputText
            />
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['email'].invalid"
            >
              <span *ngIf="checkoutForm['email'].errors.required"
                >Email is Required</span
              >
              <span *ngIf="checkoutForm['email'].errors.email"
                >Email is Invalid</span
              >
            </small>
          </div>
          <div class="field col">
            <label for="phone">Phone</label><br />
            <p-inputMask
              mask="(999) 999-9999"
              formControlName="phone"
              placeholder="(999)
                999-9999"
              styleClass="inputfield w-full"
            ></p-inputMask>
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['phone'].invalid"
              >Phone is required
            </small>
          </div>
        </div>

        <div class="formgrid grid fluid">
          <div class="field col">
            <label for="name">Street</label>
            <input
              formControlName="street"
              id="street"
              type="text"
              class="inputfield w-full"
              pInputText
            />
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['street'].invalid"
              >Street is required</small
            >
          </div>
          <div class="field col">
            <label for="name">Apartment</label>
            <input
              formControlName="apartment"
              id="apartment"
              type="text"
              class="inputfield w-full"
              pInputText
            />
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['apartment'].invalid"
              >Apartment is required</small
            >
          </div>
          <div class="field col">
            <label for="name">Zip</label>
            <input
              formControlName="zip"
              id="zip"
              type="text"
              class="inputfield w-full"
              pInputText
            />
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['zip'].invalid"
              >Zip is required</small
            >
          </div>
        </div>

        <div class="formgrid grid fluid">
          <div class="field col-6">
            <label for="name">City</label>
            <input
              formControlName="city"
              id="city"
              type="text"
              class="inputfield w-full"
              pInputText
            />
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['city'].invalid"
              >City is required</small
            >
          </div>
          <div class="field col-6">
            <label for="countInStock">Country</label><br />
            <p-dropdown
              [options]="countries"
              formControlName="country"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              filterBy="name"
              placeholder="Select a Country"
              styleClass="w-full"
            ></p-dropdown
            ><br />
            <small
              class="p-error"
              *ngIf="isSubmitted && checkoutForm['country'].invalid"
              >Country is required</small
            >
          </div>
        </div>
      </form>
    </div>
    <div class="col-4">
      <order-summary></order-summary>
      <div class="checkout-button">
        <p-button label="Place-Order" (onClick)="placeOrder()"></p-button>
      </div>
    </div>
  </div>
</div>
